import { render, staticRenderFns } from "./UserNotice.vue?vue&type=template&id=aab9a3b6&scoped=true&"
import script from "./UserNotice.vue?vue&type=script&lang=js&"
export * from "./UserNotice.vue?vue&type=script&lang=js&"
import style0 from "./UserNotice.vue?vue&type=style&index=0&id=aab9a3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab9a3b6",
  null
  
)

export default component.exports